import type { PropsWithChildren, SVGProps } from 'react';

interface SvgWithFontProps extends SVGProps<SVGSVGElement> {
  fontFamily: string;
}

export const SvgWithFont = ({
  children,
  fontFamily,
  ...props
}: PropsWithChildren<SvgWithFontProps>) => {
  return (
    <svg {...props} fontFamily={fontFamily}>
      {children}
    </svg>
  );
};
